import React from 'react';
import { BuildingIcon, StarIcon, MessageSquareIcon, MapPinIcon, PhoneIcon, GlobeIcon, MailIcon, TagsIcon, ClockIcon } from 'lucide-react';
export function DataFieldsSection() {
  return <section className="py-24 bg-slate-50" data-id="element-1896">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1897">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1898">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1899">
            Every data field from{' '}
            <span className="text-blue-600" data-id="element-1900">Google Maps</span>, enriched and
            verified
          </h2>
          <p className="text-xl text-slate-600" data-id="element-1901">
            Our Google Maps scraper extracts 50+ fields per business. From basic
            info to owner contacts — all enriched and ready to export.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1902">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1903">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1904">
              <BuildingIcon className="w-6 h-6" data-id="element-1905" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1906">
              Business name
            </h3>
            <p className="text-slate-600" data-id="element-1907">
              Exact registered name on Google Maps
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1908">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1909">
              <StarIcon className="w-6 h-6" data-id="element-1910" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1911">Rating</h3>
            <p className="text-slate-600" data-id="element-1912">Average star rating from customers</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1913">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1914">
              <MessageSquareIcon className="w-6 h-6" data-id="element-1915" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1916">
              Reviews count
            </h3>
            <p className="text-slate-600" data-id="element-1917">Total number of reviews received</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1918">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1919">
              <MapPinIcon className="w-6 h-6" data-id="element-1920" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1921">
              Full address
            </h3>
            <p className="text-slate-600" data-id="element-1922">Street, city, state, and zip code</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1923">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1924">
              <PhoneIcon className="w-6 h-6" data-id="element-1925" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1926">
              Phone number
            </h3>
            <p className="text-slate-600" data-id="element-1927">Direct business line for calling</p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1928">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1929">
              <GlobeIcon className="w-6 h-6" data-id="element-1930" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1931">
              Website URL
            </h3>
            <p className="text-slate-600" data-id="element-1932">
              Link to the official business website
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1933">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1934">
              <MailIcon className="w-6 h-6" data-id="element-1935" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1936">
              Email address
            </h3>
            <p className="text-slate-600" data-id="element-1937">
              Verified contact emails when available
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1938">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1939">
              <TagsIcon className="w-6 h-6" data-id="element-1940" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1941">
              Categories
            </h3>
            <p className="text-slate-600" data-id="element-1942">
              Primary and secondary business types
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1943">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1944">
              <ClockIcon className="w-6 h-6" data-id="element-1945" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1946">
              Operating hours
            </h3>
            <p className="text-slate-600" data-id="element-1947">Daily open and close times</p>
          </div>
        </div>
      </div>
    </section>;
}